var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "submit-tender clearfix",
      staticStyle: { display: "inline-block" },
    },
    [
      _c(
        "button",
        {
          class: _vm.className,
          attrs: { type: "button", id: "decline_tender" },
          on: {
            click: function ($event) {
              return _vm.init()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("action.reject")))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "reveal",
          attrs: { id: "specifyReasonModal" + _vm.id, "data-reveal": "" },
        },
        [
          _c("div", { staticClass: "modal-container" }, [
            _c("p", { staticClass: "confirm-header" }, [
              _vm._v(_vm._s(_vm.$t("tender.tmview.rejectHint"))),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "emphasis" }, [
              _vm._v(_vm._s(_vm.$t("comment"))),
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                { name: "autosize", rawName: "v-autosize" },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.rejectReason,
                  expression: "rejectReason",
                },
              ],
              staticClass: "autosize",
              attrs: {
                type: "text",
                placeholder: _vm.$t("tender.tmview.rejectPlaceholder"),
                required: "",
              },
              domProps: { value: _vm.rejectReason },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.rejectReason = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _vm.apprErrHint
              ? _c(
                  "span",
                  { staticClass: "form-error is-visible appr-error-message" },
                  [_vm._v("\n        " + _vm._s(_vm.apprErrHint) + "\n      ")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row align-right nav_btn" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button", "aria-label": "Close reveal" },
                on: {
                  click: function ($event) {
                    return _vm.closeSpecifyReasonModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "submit" },
                on: {
                  click: function ($event) {
                    return _vm.reject()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.reject")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "confirmMessageModal",
          attrs: { modalId: "confirmMessageModal" + _vm.id },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { staticClass: "modal-pure-text" }, [
              _vm._v(_vm._s(_vm.$t("hint.confirmTenderDecline"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "submit" },
                on: {
                  click: function ($event) {
                    return _vm.closeModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("hint.okay")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }